import { h } from 'preact';
import { TextAreaEntry } from '@epx/flow';

const EVENT_TYPES = [
  'epx:IntermediateCatchEvent',
  'epx:IntermediateThrowEvent',
];

export class SfdExpressionExtension {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return EVENT_TYPES.includes(elementType);
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'sfdExpression',
        label: i18n.expression || 'Expression',
        entries: [
          {
            id: 'expressionText',
            component: () => (
              <TextAreaEntry
                id="sfd-expressionText"
                label={i18n.expressionText || 'Expression'}
                value={props.expressionText || ''}
                rows={5}
                placeholder="Enter expression..."
                description={i18n.expressionHelp || 'Expression to evaluate for this intermediate event'}
                onChange={(val) => update('expressionText', val)}
                debounce={true}
              />
            ),
          },
        ],
        isEdited: () => !!(props.expressionText),
      },
    ];
  }
}
